<template>
  <NavigationLayout :padding="true">
    <SplitLayout
      :route-param="routeParam"
      :query-param-map="queryParamMap"
      :route-component="components.routeComponent">
      <Table
        :data="tasks"
        :config="config"
        @row-selected="rowSelected">
        <template slot="controls">
          <vk-icon-button
            :href="createNewObjectLink"
            ratio="0.85"
            icon="plus"
          />
        </template>
      </Table>
    </SplitLayout>
  </NavigationLayout>
</template>

<script>
  import NavigationLayout from '../../components/layout/NavigationLayout'
  import SplitLayout from '../../components/layout/SplitLayout'
  import SplitViewMixin from '../../mixins/split-view'
  import Task from '../../views/projects/Task'
  import Table from '../../components/global/Table'
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        tasks: 'project/tasks'
      })
    },
    data() {
      return {
        config: null
      }
    },
    created() {
      this.setup('tasks', 'taskId', Task)
      this.config = this.createTableConfig('nav.tasks', 'projects.no_task_found')

      // Load Tasks
      this.loading = true
      this.$store.dispatch('project/loadTasks', {
        appId: this.$route.params.appId
      }).finally(() => this.loading = false)
    },
    mixins: [
      SplitViewMixin
    ],
    components: {
      Table,
      SplitLayout,
      NavigationLayout
    }
  }
</script>